<script lang="ts">
  import { cdnUrls } from "../data/cdnUrls";
  import { t, translationExists } from "../stores/translations";
  import { ButtonType } from "../types/button-type";
  import { googleTagManagerStore } from "../stores/googleTagManager";
  import Button from "./shared/Button.svelte";

  export let questionSlug: string;
  export let answerSlug: string;
  export let url: string;

  $: imgSrc =
    answerSlug === "physical-complaints"
      ? cdnUrls.images["physical-complaints"]
      : cdnUrls.images["new-bed"];

  function openUrl() {
    const urlType =
      answerSlug === "physical-complaints"
        ? "make-an-appointment"
        : "view-all-beds";

    if ($googleTagManagerStore.gtmActive) {
      googleTagManagerStore.openUrl(urlType);
    }

    window.open(url);
  }
</script>

<div class="info-container">
  <img src={imgSrc} alt="Woman giving pillow advice" />

  <div class="content-button-container">
    <div class="text-content">
      {#if $translationExists(`questions.${questionSlug}.additional-information.${answerSlug}.header`)}
        <h2>
          {$t(
            `questions.${questionSlug}.additional-information.${answerSlug}.header`
          )}
        </h2>
      {/if}
      <p>
        {$t(
          `questions.${questionSlug}.additional-information.${answerSlug}.content`
        )}
      </p>
    </div>

    <div class="button-container">
      <Button type={ButtonType.Secondary} on:click={openUrl}>
        {$t(
          `questions.${questionSlug}.additional-information.${answerSlug}.button`
        )}
      </Button>
    </div>
  </div>
</div>

<style lang="scss">
  @import "src/lib/styles/variables.scss";
  @import "src/lib/styles/mixins.scss";

  .info-container {
    background-color: $color-primary;
    width: 100%;
    border-radius: 0.75rem;
    flex-direction: column;
    display: flex;
    overflow: hidden;

    & > img {
      width: 100%;
    }

    & > .content-button-container {
      display: flex;
      flex-direction: column;

      & > .text-content {
        margin: 1.5rem 0.75rem 1rem;
        display: flex;
        flex-direction: column;
        align-items: center;

        & > h2 {
          margin: 0;
          font-family: "Roboto";
          font-size: $font-size-extra-large;
          font-weight: $font-weight-medium;
          color: $color-white;
          margin: 0 0 0.5rem;
          line-height: 1.5rem;
        }

        & > p {
          margin: 0;
          font-family: "Roboto";
          font-size: $font-size-medium;
          color: $color-white;
          margin: 0;
          line-height: 1.5rem;
          text-align: center;
        }
      }

      & > .button-container {
        margin: 0 2rem 1.5rem;
      }
    }
  }

  @include desktop {
    .info-container {
      display: flex;
      flex-direction: row;

      & > img {
        height: 250px;
        min-width: 350px;
        border-radius: 0;
      }

      & > .content-button-container {
        justify-content: center;

        & > .button-container {
          margin-bottom: 0;
        }
      }
    }
  }
</style>
